import React, { useEffect } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaBook,
  FaUser,
  FaRegCommentDots,
} from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Contact.css";

const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="contact-page">
      {/* Banner superior */}
      <div className="contact-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Contáctanos</h1>
          <p className="lead">
            Estamos aquí para ayudarte. Escríbenos o visítanos en San Juan de Miraflores.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5">
        <div className="row g-5">
       
          <div className="col-md-5" data-aos="fade-right">
            <h3 className="section-title">Teléfonos</h3>
            <p><FaPhoneAlt className="icon" /> <strong>Mesa de partes:</strong> 01-2762910</p>
            <p><FaPhoneAlt className="icon" /> <strong>Secretaría de Dirección:</strong> 01-4661035</p>

            <h3 className="section-title mt-4">Correos</h3>
            <p><FaEnvelope className="icon" /> <strong>Atención al estudiante:</strong> informes@iestpgildaballivian.edu.pe</p>
            <p><FaEnvelope className="icon" /> <strong>Soporte técnico:</strong> soporte@iestpgildaballivian.edu.pe</p>
            <p><FaEnvelope className="icon" /> <strong>Admisión:</strong> admision@iestpgildaballivian.edu.pe</p>
            <p><FaEnvelope className="icon" /> <strong>Bolsa de trabajo:</strong> bolsadetrabajo@iestpgildaballivian.edu.pe</p>

            <h3 className="section-title mt-4">Redes Sociales</h3>
            <p><FaFacebook className="icon" /> <a href="https://www.facebook.com/IESTPGILDABALLIVIANOFICIAL" target="_blank" rel="noreferrer">Facebook Oficial</a></p>
            <p><FaBook className="icon" /> <a href="#">Libro de Reclamaciones</a></p>
          </div>

          {/* Mapa y formulario */}
          <div className="col-md-7" data-aos="fade-left">
            <h3 className="section-title">¿Cómo llegar?</h3>
            <p>
              <FaMapMarkerAlt className="icon" /> Av. Vargas Machuca N° 315 (Frente al Banco de Crédito),
              Urb. "San Juan", San Juan de Miraflores - Lima.
            </p>

            <div className="map-container mt-3">
              <iframe
                title="Mapa IESTP Gilda Ballivián"               
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3900.2179680028758!2d-76.9770377251729!3d-12.165558488080606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105b851de5dffc1%3A0xa7c420906cc5e7f8!2sIESTP%20Gilda%20Liliana%20Ballivian%20Rosado!5e0!3m2!1ses!2spe!4v1761944551910!5m2!1ses!2spe"
                width="100%"
                height="300"
                style={{ border: "0", borderRadius: "12px" }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
